module.exports = "/images/sb.svg?0318a73bc75c9f5ecf7029e711639ef9";